@if (orderItem) {
  <ng-container
    *ngTemplateOutlet="mobileDevice ? mobileView : desktopView"
  ></ng-container>
}

<ng-template #desktopView>
  <ng-container
    *ngTemplateOutlet="
      viewType === 'list-item' ? listItemView : detailedItemView
    "
  ></ng-container>
</ng-template>

<ng-template #listItemView>
  <div class="product-order-item--header" [ngClass]="classes">
    <div class="header--row">
      <div class="description">
        <div class="description__body d-flex flex-column full-width">
          <a href="#" (click)="showProductDetails()" class="link">
            <h1
              class="product-label"
              [innerHTML]="product.label | safeContent"
            ></h1>
          </a>
          <span class="d-block mb-2 font-5 fw-normal mb-2"
            >SKU:&nbsp;{{ product.skus[0].getDisplaySkuID() }}</span
          >
          <app-product-flag-container
            [product]="product"
          ></app-product-flag-container>
          <div class="d-block">
            @for (type of product.sustainability; track $index) {
              <app-product-sustainable-item
                [sustainableType]="type"
                [showBorder]="true"
              ></app-product-sustainable-item>
            }
          </div>
          @if (isProductRecommended) {
            <app-product-recommened-quantity
              [currentQty]="product.recommended_qty_current"
              [recommendedQty]="product.recommended_qty_expected"
            ></app-product-recommened-quantity>
          }
          <div class="d-flex align-items-baseline">
            @if (readonly && !showHideItemButton) {
              <div>
                @if (orderItem.shipment_timing && canShowShipmentTiming) {
                  <span class="fw-bold me-3"
                    >{{ orderItem.shipment_timing }}&nbsp;</span
                  >
                }
                @if (orderItem.backorderedMessage && orderItem.estimatedDates) {
                  <div class="me-3">
                    <span class="fw-bold"
                      >{{ orderItem.backorderedMessage }}
                    </span>
                    {{ orderItem.estimatedDates }}
                  </div>
                }
                @if (orderItem.expected_ship_at) {
                  <div class="me-3">
                    <span class="fw-bold">Shipment Update: </span>
                    Estimated Ship Date is
                    {{ orderItem.expected_ship_at | dateFormat: 'MMM D, YYYY' }}
                  </div>
                }
              </div>
            }

            @if (canShowVendor) {
              <app-vendor-modal
                [vendorLabel]="orderItem.vendor"
                class="description__modal"
              ></app-vendor-modal>
            }
          </div>

          @if (showHideItemButton) {
            <div class="d-flex align-items-center">
              @if (showProductPrice) {
                <div class="me-4">
                  <app-product-order-item-price
                    [orderItem]="orderItem"
                    viewType="grid-item"
                    [ngClass]="viewType"
                    fontSize="font-2"
                  >
                  </app-product-order-item-price>
                </div>
              }
              @if (showReorderButton) {
                @if (orderItem.product.replacedProductId) {
                  <div class="">
                    <a
                      class="link link-underline"
                      (click)="showProduct(orderItem.product)"
                    >
                      Order Replacement <i class="fas fa-bolt"></i>
                    </a>
                  </div>
                }
                @if (
                  !orderItem.product.replacedProductId &&
                  order.isOnDemand &&
                  !orderItem.isCancelled
                ) {
                  <div>
                    @if (orderItem.product.productActive) {
                      <a
                        class="link link-underline"
                        (click)="reorderItem.emit()"
                        >Reorder Item <i class="fas fa-redo"></i
                      ></a>
                    }
                    @if (!orderItem.product.productActive) {
                      <span class="color-gray"
                        >This Item cannot be reordered</span
                      >
                    }
                  </div>
                }
              }
              @if (readonly) {
                <div class="ms-3">
                  @if (orderItem.shipment_timing && canShowShipmentTiming) {
                    <span class="fw-bold"
                      >{{ orderItem.shipment_timing }}&nbsp;</span
                    >
                  }
                  @if (
                    orderItem.backorderedMessage && orderItem.estimatedDates
                  ) {
                    <div class="ms-3">
                      <span class="fw-bold uppercase"
                        >{{ orderItem.backorderedMessage }}
                      </span>
                      {{ orderItem.estimatedDates }}
                    </div>
                  }
                  @if (orderItem.expected_ship_at) {
                    <div class="ms-3">
                      <span class="fw-bold uppercase">Shipment Update: </span>
                      Estimated Ship Date is
                      {{
                        orderItem.expected_ship_at | dateFormat: 'MMM D, YYYY'
                      }}
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      </div>

      @if (!showHideItemButton) {
        <!--in stock-->
        @if (showInStock && !product.hasVariations && !product.isBuyingWindow) {
          <app-product-order-item-in-stock
            [product]="product"
            [quantity]="orderItem.quantity"
            [orderItemId]="orderItem?.id"
            [viewType]="viewType"
            fontSize="font-4"
            label="Availability:"
            class="availability--container"
          ></app-product-order-item-in-stock>
        }
        <!--min order-->
        @if (showMinOrder) {
          <app-product-order-item-min-max
            [shouldShowAvailableQuantity]="!product.hasVariations"
            [isRecommended]="isProductRecommended"
            [headerPosition]="true"
            [orderItem]="orderItem"
            [viewType]="viewType"
            class="me-3"
          ></app-product-order-item-min-max>
        }
        <!--price-->
        @if (showProductPrice) {
          <app-product-order-item-price
            [orderItem]="orderItem"
            [ngClass]="viewType"
            fontSize="font-2"
          >
          </app-product-order-item-price>
        }
      }

      @if (showHideItemButton) {
        <div>
          <button
            class="btn btn-icon"
            (click)="toggleItemVisibility()"
            [title]="orderItem.hidden ? 'Show Details' : 'Hide Details'"
          >
            <img
              [src]="
                orderItem.hidden
                  ? '/assets/img/icons/plus-circle.svg'
                  : '/assets/img/icons/minus-circle.svg'
              "
            />
          </button>
        </div>
      }
    </div>
  </div>
</ng-template>

<ng-template #detailedItemView>
  <div class="product-order-item--header" [ngClass]="classes">
    <div class="px-3">
      <div class="header--row">
        <h1
          class="product-label color--primary-blue my-0"
          [innerHTML]="product.label | safeContent"
        ></h1>
        <span class="mb-2"
          >SKU:&nbsp;{{ product.skus[0].getDisplaySkuID() }}</span
        >
        <app-product-flag-container
          [product]="product"
        ></app-product-flag-container>
        <div class="d-block">
          @for (type of product.sustainability; track $index) {
            <app-product-sustainable-item
              [sustainableType]="type"
              [showBorder]="true"
            ></app-product-sustainable-item>
          }
        </div>

        <div
          class="product--details mb-1"
          [ngClass]="{ 'pb-3': product.hasVariations }"
        >
          <div class="d-flex flex-column">
            @if (isProductRecommended) {
              <app-product-recommened-quantity
                [recommendedQty]="product.recommended_qty_expected"
                [currentQty]="product.recommended_qty_current"
              ></app-product-recommened-quantity>
            }

            @if (showMinOrder) {
              <app-product-order-item-min-max
                [shouldShowAvailableQuantity]="!product.hasVariations"
                [orderItem]="orderItem"
                [headerPosition]="true"
                [isRecommended]="isProductRecommended"
                [viewType]="viewType"
                fontSize="font-4"
              >
              </app-product-order-item-min-max>
            }

            @if (
              showInStock && !product.hasVariations && !product.isBuyingWindow
            ) {
              <app-product-order-item-in-stock
                [product]="product"
                [quantity]="orderItem.quantity"
                [orderItemId]="orderItem?.id"
                [viewType]="viewType"
                fontSize="font-4"
                label="Availability:"
                class="availability--container"
              ></app-product-order-item-in-stock>
            }

            @if (canShowVendor) {
              <app-vendor-modal
                [vendorLabel]="orderItem.vendor"
                class="description__modal"
              ></app-vendor-modal>
            }

            @if (!discontinued && product.isCustomizable) {
              <div class="header--row subheader justify-content-start">
                <span>Custom Min Required:</span>
                <span class="fw-bold ms-2">
                  {{ product.customization.custom_min_qty }}
                </span>
              </div>
            }

            @if (showReorderButton && readonly) {
              @if (orderItem.product.replacedProductId) {
                <div class="">
                  <a
                    class="link link-underline"
                    (click)="showProduct(orderItem.product)"
                  >
                    Order Replacement <i class="fas fa-bolt"></i>
                  </a>
                </div>
              }
              @if (
                !orderItem.product.replacedProductId &&
                order.isOnDemand &&
                !orderItem.isCancelled
              ) {
                <div class="">
                  @if (orderItem.product.productActive) {
                    <a class="link link-underline" (click)="reorderItem.emit()"
                      >Reorder Item <i class="fas fa-redo"></i>
                    </a>
                  }
                  @if (!orderItem.product.productActive) {
                    <span class="color-gray"
                      >This Item cannot be reordered</span
                    >
                  }
                </div>
              }
            }
          </div>
          <div class="description__product-price">
            @if (showProductPrice) {
              <app-product-order-item-price
                [orderItem]="orderItem"
                [viewType]="viewType"
                fontSize="font-2"
                class="pe-3"
              >
              </app-product-order-item-price>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #mobileView>
  <ng-container
    *ngTemplateOutlet="readonly ? mobileReadOnlyView : mobileDetailedView"
  ></ng-container>
</ng-template>

<ng-template #mobileDetailedView>
  <div class="product-order-item--header" [ngClass]="classes">
    <div>
      <div class="header--row">
        <div
          class="product--details"
          [ngClass]="{ 'pb-3': product.hasVariations }"
        >
          <div class="d-flex flex-column">
            <span>SKU:&nbsp;{{ product.skus[0].getDisplaySkuID() }}</span>
            <app-product-flag-container
              [product]="product"
            ></app-product-flag-container>
            <div class="d-block">
              @for (type of product.sustainability; track $index) {
                <app-product-sustainable-item
                  [sustainableType]="type"
                  [showBorder]="true"
                ></app-product-sustainable-item>
              }
            </div>

            @if (isProductRecommended) {
              <app-product-recommened-quantity
                [recommendedQty]="product.recommended_qty_expected"
                [currentQty]="product.recommended_qty_current"
              ></app-product-recommened-quantity>
            }
            @if (showMinOrder) {
              <app-product-order-item-min-max
                [orderItem]="orderItem"
                [shouldShowAvailableQuantity]="!product.hasVariations"
                [headerPosition]="true"
                [isRecommended]="isProductRecommended"
                [viewType]="viewType"
                fontSize="font-4"
              >
              </app-product-order-item-min-max>
            }

            @if (
              showInStock && !product.hasVariations && !product.isBuyingWindow
            ) {
              <app-product-order-item-in-stock
                [product]="product"
                [quantity]="orderItem.quantity"
                [orderItemId]="orderItem?.id"
                [viewType]="viewType"
                fontSize="font-4"
                label="Availability:"
                class="availability--container"
              ></app-product-order-item-in-stock>
            }

            @if (canShowVendor) {
              <app-vendor-modal
                [vendorLabel]="orderItem.vendor"
                class="description__modal"
              ></app-vendor-modal>
            }

            @if (product.isCustomizable) {
              <div class="header--row subheader justify-content-start">
                <span>Custom Min Required:</span>
                <span class="fw-bold ms-2">
                  {{ product.customization.custom_min_qty }}
                </span>
              </div>
            }
          </div>
          <div class="description__product-price">
            @if (showProductPrice) {
              <app-product-order-item-price
                [orderItem]="orderItem"
                [viewType]="viewType"
                fontSize="font-2"
                class="pe-3"
              >
              </app-product-order-item-price>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #mobileReadOnlyView>
  @if (viewType === 'list-item') {
    <div class="product-order-item--header p-0 ms-3 list-item">
      <div class="header--row mw-calc-100-55">
        <div class="description full-width">
          <div class="description__body d-flex flex-column full-width">
            <a href="#" class="link" (click)="showProductDetails()">
              <h1
                class="product-label text-hidden-ellipsis"
                [innerHTML]="product.label | safeContent"
              ></h1>
            </a>
            <span class="d-block mb-2 font-5 fw-normal mb-2"
              >SKU:&nbsp;{{ product.skus[0].getDisplaySkuID() }}</span
            >
            <app-product-flag-container
              [product]="product"
            ></app-product-flag-container>
            <div class="d-block">
              @for (type of product.sustainability; track $index) {
                <app-product-sustainable-item
                  [sustainableType]="type"
                  [showBorder]="true"
                ></app-product-sustainable-item>
              }
            </div>
            <div>
              @if (orderItem.shipment_timing && canShowShipmentTiming) {
                <span class="fw-bold mt-3"
                  >{{ orderItem.shipment_timing }}&nbsp;</span
                >
              }
              @if (orderItem.backorderedMessage && orderItem.estimatedDates) {
                <div class="mt-3">
                  <span class="fw-bold uppercase"
                    >{{ orderItem.backorderedMessage }} </span
                  >{{ orderItem.estimatedDates }}
                </div>
              }
              @if (orderItem.expected_ship_at) {
                <div class="mt-3">
                  <span class="fw-bold uppercase">Shipment Update: </span>
                  Estimated Ship Date is
                  {{ orderItem.expected_ship_at | dateFormat: 'MMM D, YYYY' }}
                </div>
              }
            </div>
            @if (canShowVendor) {
              <app-vendor-modal
                [vendorLabel]="orderItem.vendor"
                class="description__modal"
              ></app-vendor-modal>
            }
            <div class="d-flex align-items-center">
              @if (showReorderButton) {
                @if (orderItem.product.replacedProductId) {
                  <div class="mt-3">
                    <a
                      class="link link-underline"
                      (click)="showProduct(orderItem.product)"
                    >
                      Order Replacement <i class="fas fa-bolt"></i>
                    </a>
                  </div>
                }
                @if (
                  !orderItem.product.replacedProductId &&
                  order.isOnDemand &&
                  !orderItem.isCancelled
                ) {
                  <div class="mt-3">
                    @if (orderItem.product.productActive) {
                      <a
                        class="link link-underline"
                        (click)="reorderItem.emit()"
                        >Reorder Item <i class="fas fa-redo"></i
                      ></a>
                    }
                    @if (!orderItem.product.productActive) {
                      <span class="color-gray"
                        >This Item cannot be reordered</span
                      >
                    }
                  </div>
                }
              }
            </div>
          </div>
        </div>
        @if (showHideItemButton) {
          <div>
            <button
              class="btn btn-icon"
              (click)="toggleItemVisibility()"
              [title]="orderItem.hidden ? 'Show Details' : 'Hide Details'"
            >
              <img
                [src]="
                  orderItem.hidden
                    ? '/assets/img/icons/plus-circle.svg'
                    : '/assets/img/icons/minus-circle.svg'
                "
              />
            </button>
          </div>
        }
      </div>
    </div>
  } @else {
    <div class="product-order-item--header p-0 ms-3 detailed">
      <div class="header--row">
        <div class="description full-width">
          <div class="description__body d-flex flex-column full-width">
            <span class="d-block mb-2 font-5 fw-normal mb-2"
              >SKU:&nbsp;{{ product.skus[0].getDisplaySkuID() }}</span
            >
            <app-product-flag-container
              [product]="product"
            ></app-product-flag-container>
            <div class="d-block">
              @for (type of product.sustainability; track $index) {
                <app-product-sustainable-item
                  [sustainableType]="type"
                  [showBorder]="true"
                ></app-product-sustainable-item>
              }
            </div>
            <div>
              @if (orderItem.shipment_timing && canShowShipmentTiming) {
                <span class="fw-bold mt-3"
                  >{{ orderItem.shipment_timing }}&nbsp;</span
                >
              }
              @if (orderItem.backorderedMessage && orderItem.estimatedDates) {
                <div class="mt-3">
                  <span class="fw-bold uppercase"
                    >{{ orderItem.backorderedMessage }} </span
                  >{{ orderItem.estimatedDates }}
                </div>
              }
              @if (orderItem.expected_ship_at) {
                <div class="mt-3">
                  <span class="fw-bold uppercase">Shipment Update: </span>
                  Estimated Ship Date is
                  {{ orderItem.expected_ship_at | dateFormat: 'MMM D, YYYY' }}
                </div>
              }
            </div>
            @if (canShowVendor) {
              <app-vendor-modal
                [vendorLabel]="orderItem.vendor"
                class="description__modal"
              ></app-vendor-modal>
            }
            <div class="d-flex align-items-center">
              @if (showReorderButton) {
                @if (orderItem.product.replacedProductId) {
                  <div class="mt-3">
                    <a
                      class="link link-underline"
                      (click)="showProduct(orderItem.product)"
                    >
                      Order Replacement <i class="fas fa-bolt"></i>
                    </a>
                  </div>
                }
                @if (
                  !orderItem.product.replacedProductId &&
                  order.isOnDemand &&
                  !orderItem.isCancelled
                ) {
                  <div class="mt-3">
                    @if (orderItem.product.productActive) {
                      <a
                        class="link link-underline"
                        (click)="reorderItem.emit()"
                        >Reorder Item <i class="fas fa-redo"></i
                      ></a>
                    }
                    @if (!orderItem.product.productActive) {
                      <span class="color-gray"
                        >This Item cannot be reordered</span
                      >
                    }
                  </div>
                }
              }
            </div>
          </div>
        </div>
        @if (showHideItemButton) {
          <div>
            <button
              class="btn btn-icon"
              (click)="toggleItemVisibility()"
              [title]="orderItem.hidden ? 'Show Details' : 'Hide Details'"
            >
              <img
                [src]="
                  orderItem.hidden
                    ? '/assets/img/icons/plus-circle.svg'
                    : '/assets/img/icons/minus-circle.svg'
                "
              />
            </button>
          </div>
        }
      </div>
    </div>
  }
</ng-template>
